import React from "react";
import "./InvestorProfile.scss";

const InvestorProfile = ({ investorProfile }) => {
    // Dividir el texto en líneas separadas
    const profileLines = investorProfile.split(';').map((line, index) => (
        <p key={index} className="investor-profile-line">{line}</p>
    ));

    return (
        <div className="investor-profile-container">
            <h3 className="investor-profile-title">Investor Profile</h3>
            {console.log(profileLines)}
            <div className="investor-profile-content">
                {profileLines}
            </div>
        </div>
    );
};

export default InvestorProfile;
